// extracted by mini-css-extract-plugin
module.exports = {"avatar-group--stack":"styles_avatar-group--stack__Ag7YZ"};